import React, { memo } from 'react';
import { Helmet } from 'react-helmet';
import { usePage } from '../../../';
export var MetaTags = memo(function (_a) {
    var title = _a.title, description = _a.description, image = _a.image;
    var _b = usePage(), pageTitle = _b.pageTitle, pagePhotoURL = _b.pagePhotoURL, isLandingPage = _b.isLandingPage;
    var metaTitle = isLandingPage
        ? title
        : pageTitle + " | " + title;
    return (React.createElement(Helmet, null,
        React.createElement("title", null, title),
        React.createElement("meta", { key: "og:type", property: "og:type", content: "website" }),
        React.createElement("meta", { key: "og:title", property: "og:title", content: metaTitle }),
        React.createElement("meta", { key: "og:description", property: "og:description", content: description }),
        image || pagePhotoURL && React.createElement("meta", { key: "og:image", property: "og:image", content: decodeURI(image || pagePhotoURL) }),
        React.createElement("meta", { key: "twitter:card", property: "twitter:card", content: "summary" }),
        React.createElement("meta", { key: "twitter:title", property: "twitter:title", content: metaTitle }),
        React.createElement("meta", { key: "twitter:description", property: "twitter:description", content: description }),
        image || pagePhotoURL && React.createElement("meta", { key: "twitter:image", property: "twitter:image", content: decodeURI(image || pagePhotoURL) })));
});
